/** @file The socket parent bone of the mounted item under the pointer (slots only; bones are ignored). */
import { pickSlot } from '@pose2d/editor-geometry/pickSlot';
import type { Id } from '@pose2d/format/types';
import type { ToolContext, ViewportPointer } from '../../panels/viewport/viewportTypes';
import { worldAt } from '../../panels/viewport/worldAt';

/** The slot's CURRENT attachment (pose.slotAttachment) must be mounted (`mount`) on a socket; else null. */
export function itemAt(ctx: ToolContext, p: ViewportPointer): Id | null {
  const w = worldAt(ctx, p);
  const slot = pickSlot(ctx.skeleton, w[0], w[1])?.slot ?? -1;
  const att = ctx.data.attachments[ctx.pose.slotAttachment[slot] ?? -1];
  const doc = att === undefined ? undefined : Object.values(ctx.doc.attachments).find((a) => a.name === att.name);
  const socket = doc?.mount === undefined ? undefined : ctx.doc.sockets[doc.mount.socket];
  return socket?.parentBone ?? null;
}
